(function () {
  'use strict';

  var NS   = 'http://www.w3.org/2000/svg';
  var TEAL = '#0dacbd';

  /* ──────────────────────────────────────────────────────────────
     Inject @keyframes into <head> so they are guaranteed to be
     in the document stylesheet regardless of Shopify CSS scoping.
  ────────────────────────────────────────────────────────────── */
  function ensureKeyframes() {
    if (document.getElementById('hl-wv-kf')) return;
    var s = document.createElement('style');
    s.id = 'hl-wv-kf';
    s.textContent =
      '@keyframes hl-wvh{from{transform:translateX(0)}to{transform:translateX(-50%)}}' +
      '@keyframes hl-wvd{from{transform:translateY(-50%)}to{transform:translateY(0%)}}';
    document.head.appendChild(s);
  }

  /* ──────────────────────────────────────────────────────────────
     DESKTOP — horizontal waves
     SVG: width 200% (CSS class), animated translateX(0 → -50%).
     -50% of SVG width = -100% of container = one seamless tile.
     max-width: none on .wv-layer svg overrides Dawn's svg reset.
  ────────────────────────────────────────────────────────────── */
  var TOTAL_W = 4000;
  var CY      = 100;

  var DESK_WAVES = [
    { amp: 38, wl: 400, dur: 14,  phase: 0.00 },
    { amp: 55, wl: 500, dur: 20,  phase: 1.26 },
    { amp: 22, wl: 250, dur: 9,   phase: 2.51 },
    { amp: 44, wl: 400, dur: 17,  phase: 3.77 },
    { amp: 30, wl: 500, dur: 12,  phase: 5.03 },
    { amp: 16, wl: 200, dur: 7,   phase: 0.94 },
  ];

  var DESK_CRISP_SW = [2.5, 0.9, 1.6, 2.0, 1.2, 0.7];
  var DESK_CRISP_AL = [0.62, 0.50, 0.55, 0.58, 0.48, 0.40];
  var DESK_GLOW_SW  = [5.5, 2.5, 4.0, 4.5, 3.2, 2.0];
  var DESK_GLOW_AL  = [0.42, 0.30, 0.36, 0.40, 0.32, 0.24];

  function makeHPath(amp, wl, phase) {
    var d = '';
    for (var x = 0; x <= TOTAL_W; x += 3) {
      var y = (CY + amp * Math.sin(2 * Math.PI * x / wl + phase)).toFixed(1);
      d += x === 0 ? ('M0,' + y) : ('L' + x + ',' + y);
    }
    return d;
  }

  function buildHSvg(w, sw, alpha) {
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 ' + TOTAL_W + ' 200');
    svg.setAttribute('preserveAspectRatio', 'none');
    svg.style.animation = 'hl-wvh ' + w.dur + 's linear infinite';

    var p = document.createElementNS(NS, 'path');
    p.setAttribute('d', makeHPath(w.amp, w.wl, w.phase));
    p.setAttribute('stroke', TEAL);
    p.setAttribute('stroke-width', sw);
    p.setAttribute('fill', 'none');
    p.setAttribute('opacity', alpha);
    svg.appendChild(p);
    return svg;
  }

  /* ──────────────────────────────────────────────────────────────
     MOBILE — vertical waves, flowing downward
     SVG: height 200%, animated translateY(-50% → 0%).
  ────────────────────────────────────────────────────────────── */
  var TOTAL_H = 600;
  var MOB_VBW = 400;
  var CX_MOB  = 200;

  var MOB_WAVES = [
    { amp: 32, wl: 150, dur: 9,  phase: 0.00 },
    { amp: 42, wl: 100, dur: 13, phase: 1.26 },
    { amp: 22, wl: 75,  dur: 6,  phase: 2.51 },
    { amp: 38, wl: 150, dur: 11, phase: 3.77 },
    { amp: 28, wl: 100, dur: 8,  phase: 5.03 },
  ];

  var MOB_CRISP_SW = [2.5, 0.9, 1.6, 2.0, 1.2];
  var MOB_CRISP_AL = [0.62, 0.50, 0.55, 0.58, 0.48];
  var MOB_GLOW_SW  = [5.5, 2.5, 4.0, 4.5, 3.2];
  var MOB_GLOW_AL  = [0.42, 0.30, 0.36, 0.40, 0.32];

  function makeVPath(amp, wl, phase) {
    var d = '';
    for (var y = 0; y <= TOTAL_H; y += 3) {
      var x = (CX_MOB + amp * Math.sin(2 * Math.PI * y / wl + phase)).toFixed(1);
      d += y === 0 ? ('M' + x + ',0') : ('L' + x + ',' + y);
    }
    return d;
  }

  function buildVSvg(w, sw, alpha) {
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 ' + MOB_VBW + ' ' + TOTAL_H);
    svg.setAttribute('preserveAspectRatio', 'none');
    svg.style.animation = 'hl-wvd ' + w.dur + 's linear infinite';

    var p = document.createElementNS(NS, 'path');
    p.setAttribute('d', makeVPath(w.amp, w.wl, w.phase));
    p.setAttribute('stroke', TEAL);
    p.setAttribute('stroke-width', sw);
    p.setAttribute('fill', 'none');
    p.setAttribute('opacity', alpha);
    svg.appendChild(p);
    return svg;
  }

  function init() {
    ensureKeyframes();

    var crispEl = document.getElementById('wv-crisp');
    var glowEl  = document.getElementById('wv-glow');
    if (crispEl && glowEl) {
      DESK_WAVES.forEach(function (w, i) {
        crispEl.appendChild(buildHSvg(w, DESK_CRISP_SW[i], DESK_CRISP_AL[i]));
        glowEl.appendChild(buildHSvg(w,  DESK_GLOW_SW[i],  DESK_GLOW_AL[i]));
      });
    }

    var mobCrispEl = document.getElementById('wv-mob-crisp');
    var mobGlowEl  = document.getElementById('wv-mob-glow');
    if (mobCrispEl && mobGlowEl) {
      MOB_WAVES.forEach(function (w, i) {
        mobCrispEl.appendChild(buildVSvg(w, MOB_CRISP_SW[i], MOB_CRISP_AL[i]));
        mobGlowEl.appendChild(buildVSvg(w,  MOB_GLOW_SW[i],  MOB_GLOW_AL[i]));
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.hl-footer')) {
      var old = document.getElementById('hl-wv-kf');
      if (old) old.remove();
      init();
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target.querySelector('.hl-footer')) {
      var old = document.getElementById('hl-wv-kf');
      if (old) old.remove();
    }
  });
})();
